import React from 'react';
import NxtbnModal from '../../components/Modal';
import RenderMeta from '../common/renderMeta';

import { useQuery, gql } from '@apollo/client';


const GET_ORDERED_DEVICE_INFO = gql`
  query GetOrderDetails($alias: UUID!) {
    orderDeviceMetas(order_Alias: $alias) {
      edges {
        node {
          browser
          browserVersion
          dbId
          deviceType
          id
          ipAddress
          operatingSystem
          userAgent
        }
      }
    }
  }
`;


interface DeviceInfoProps {
    alias: any;
    isOpen: boolean;
    onClose: () => void;
}

const DeviceInfo: React.FC<DeviceInfoProps> = ({ alias, isOpen, onClose }) => {

    const { data, loading, error, refetch } = useQuery(GET_ORDERED_DEVICE_INFO, {
      variables: { alias: alias },
      notifyOnNetworkStatusChange: true,
    });
  
  

  return (
    <NxtbnModal size='xl' isOpen={isOpen} onClose={onClose}>
      <div className="overflow-hidden p-6 bg-gradient-to-b from-gray-50 to-white">
      <div className="bg-gray-50 shadow-md rounded-lg p-6 border border-gray-200">
          <RenderMeta data={data?.orderDeviceMetas || {}} title="Custom Device Info" />
        </div>

        {/* Footer Actions */}
        <div className="mt-6 flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="inline-flex items-center justify-center rounded-lg px-6 py-2.5 bg-gray-800 text-white font-medium text-sm transition-colors hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-gray-800 focus:ring-offset-2"
          >
            Close
          </button>
        </div>
      </div>
    </NxtbnModal>
  );
};

export default DeviceInfo;